"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  PublishPriceTab = _require.PublishPriceTab;
const formatPublishPriceTab = properties => {
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$descripti = properties.description,
    description = _properties$descripti === void 0 ? '' : _properties$descripti,
    _properties$descripti2 = properties.descriptionFooter,
    descriptionFooter = _properties$descripti2 === void 0 ? '' : _properties$descripti2,
    color = properties.color,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura;
  const resultConfiguration = configuration.map((item, index) => {
    const _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$list = item.list,
      list = _item$list === void 0 ? [] : _item$list;
    const resultList = list.map((listItem, index1) => {
      const _listItem$packageSwit = listItem.packageSwitchConfiguration,
        packageSwitchConfiguration = _listItem$packageSwit === void 0 ? [] : _listItem$packageSwit,
        _listItem$packageCard = listItem.packageCardConfiguration,
        packageCardConfiguration = _listItem$packageCard === void 0 ? [] : _listItem$packageCard;
      const resultPackageSwitchConfiguration = packageSwitchConfiguration.map((packageSwitchItem, indexPackage) => {
        const _packageSwitchItem$bt = packageSwitchItem.btnTxt,
          btnTxt = _packageSwitchItem$bt === void 0 ? '' : _packageSwitchItem$bt,
          _packageSwitchItem$hr = packageSwitchItem.href,
          href = _packageSwitchItem$hr === void 0 ? '' : _packageSwitchItem$hr,
          _packageSwitchItem$co = packageSwitchItem.commodityObject,
          commodityObject = _packageSwitchItem$co === void 0 ? '{}' : _packageSwitchItem$co;
        const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
        const onCallback = function () {
          window.asyncReceiveCommodity(_objectSpread({
            href
          }, resultCommodityObject));
        };
        return _objectSpread(_objectSpread(_objectSpread({}, packageSwitchItem), resultCommodityObject), {}, {
          extendProps: {
            'report-event': 'click_publishPriceTab_packageSwitch_button',
            'report-ext1': indexPackage,
            'report-ext2': btnTxt,
            'report-ext3': href
          },
          onCallback
        });
      });
      const resultPackageCardConfiguration = packageCardConfiguration.map((packageCardItem, packageCardIndex) => {
        const _packageCardItem$btnT = packageCardItem.btnTxt,
          btnTxt = _packageCardItem$btnT === void 0 ? '' : _packageCardItem$btnT,
          _packageCardItem$href = packageCardItem.href,
          href = _packageCardItem$href === void 0 ? '' : _packageCardItem$href,
          _packageCardItem$comm = packageCardItem.commodityObject,
          commodityObject = _packageCardItem$comm === void 0 ? '{}' : _packageCardItem$comm;
        const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
        const onCallback = function () {
          window.asyncReceiveCommodity(_objectSpread({
            href
          }, resultCommodityObject));
        };
        return _objectSpread(_objectSpread(_objectSpread({}, packageCardItem), resultCommodityObject), {}, {
          extendProps: {
            'report-event': 'click_publishPriceTab_packageCard_button',
            'report-ext1': packageCardIndex,
            'report-ext2': btnTxt,
            'report-ext3': href
          },
          onCallback
        });
      });
      return _objectSpread(_objectSpread({}, listItem), {}, {
        packageSwitchConfiguration: resultPackageSwitchConfiguration,
        packageCardConfiguration: resultPackageCardConfiguration
      });
    });
    return {
      title,
      list: resultList,
      key: index + 1
    };
  });
  return {
    modTitle,
    description,
    descriptionFooter,
    bgColor: color,
    configuration: resultConfiguration
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit // {(event: string) => void | Promise<void>} 监听事件
}) {
  if (Object.keys(data).length > 1) {
    const _formatPublishPriceTa = formatPublishPriceTab(data),
      _formatPublishPriceTa2 = _formatPublishPriceTa.modTitle,
      modTitle = _formatPublishPriceTa2 === void 0 ? '' : _formatPublishPriceTa2,
      _formatPublishPriceTa3 = _formatPublishPriceTa.configuration,
      configuration = _formatPublishPriceTa3 === void 0 ? [] : _formatPublishPriceTa3,
      _formatPublishPriceTa4 = _formatPublishPriceTa.description,
      description = _formatPublishPriceTa4 === void 0 ? '' : _formatPublishPriceTa4,
      _formatPublishPriceTa5 = _formatPublishPriceTa.descriptionFooter,
      descriptionFooter = _formatPublishPriceTa5 === void 0 ? '' : _formatPublishPriceTa5,
      bgColor = _formatPublishPriceTa.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_publishPriceTab', componentKey, modTitle])), /*#__PURE__*/React.createElement(PublishPriceTab, {
      flexTitle: modTitle,
      description: description,
      descriptionFooter: descriptionFooter,
      configuration: configuration.map((item, index) => _objectSpread(_objectSpread({}, item), {}, {
        key: index + 1
      })),
      style: bgStyle
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}